import { createClient } from '@supabase/supabase-js';

// Read from environment variables first (set in .env locally, in Vercel for prod).
// Falls back to the public project URL/anon key so the app keeps working if env
// vars aren't set. The anon key is safe to expose — it's meant for client-side
// use and is gated by your Supabase Row Level Security policies.
const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL ||
  'https://meozwbxyuggdesaaazwu.supabase.co';
const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1lb3p3Ynh5dWdnZGVzYWFhend1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYyNzEzMTgsImV4cCI6MjA5MTg0NzMxOH0.67lQKQ5IeHSEJJhIoQylcl5Jft0pHXFqvAfsL5N77h0';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Load all data for a user
export async function loadUserData(userId) {
  try {
    const { data, error } = await supabase
      .from('user_data')
      .select('*')
      .eq('user_id', userId)
      .single();
    if (error && error.code === 'PGRST116') return null; // No row yet
    if (error) throw error;
    return data;
  } catch (e) {
    console.error('loadUserData error:', e);
    return null;
  }
}

// Save all data for a user
export async function saveUserData(userId, updates) {
  try {
    const { error } = await supabase
      .from('user_data')
      .upsert({ user_id: userId, ...updates, updated_at: new Date().toISOString() }, { onConflict: 'user_id' });
    if (error) throw error;
    return true;
  } catch (e) {
    console.error('saveUserData error:', e);
    return false;
  }
}

// Save a single field
export async function saveField(userId, field, value) {
  return saveUserData(userId, { [field]: value });
}
